import { render, staticRenderFns } from "./StateBanner.vue?vue&type=template&id=84e96ca6&scoped=true&"
import script from "./StateBanner.vue?vue&type=script&lang=js&"
export * from "./StateBanner.vue?vue&type=script&lang=js&"
import style0 from "./StateBanner.vue?vue&type=style&index=0&id=84e96ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e96ca6",
  null
  
)

export default component.exports